import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Info } from 'lucide-react';
import { buildCoverageSummary } from '../../utils/coverageSummary';

const COVERAGE_SUMMARY = buildCoverageSummary();

/**
 * Single Info icon-button, lives in the chat header. Toggles a small
 * popover with the coverage summary — replaces the old per-message
 * "Cobertura de esta búsqueda" <details> footer that used to repeat on
 * every assistant message.
 */
export default function CoverageInfo() {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('keydown', handleEsc);
    };
  }, [open]);

  return (
    <div className="relative" ref={wrapperRef}>
      <button
        onClick={() => setOpen(o => !o)}
        className="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
        title="Cobertura de esta búsqueda"
        aria-label="Cobertura de esta búsqueda"
      >
        <Info className="w-4 h-4" />
      </button>
      {open && (
        <div className="absolute right-0 bottom-full mb-2 w-80 max-w-[85vw] p-3 bg-white border border-slate-200 rounded-xl shadow-lg z-30 text-left">
          <p className="text-[11px] text-slate-500 leading-relaxed">
            {COVERAGE_SUMMARY}{' '}
            <Link
              to="/cobertura"
              className="text-indigo-500 hover:text-indigo-700 underline"
              onClick={() => setOpen(false)}
            >
              Ver cobertura completa →
            </Link>
          </p>
        </div>
      )}
    </div>
  );
}
